var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tci-solution',{attrs:{"subtitle":"工业智能制造与物联网","title":"IoT","images":_vm.$i18n.locale=="zh"?_vm.infos:_vm.infos_ja}})
}
var staticRenderFns = []

export { render, staticRenderFns }